
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiThreewayAcuatorPistonInleftRight0 as ObiThreewayAcuatorPistonInleftRight0Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-threeway-acuator-piston-inleft-right-0.js';
 
 
 

 
 export const ObiThreewayAcuatorPistonInleftRight0 = createComponent({
   react: React,
   tagName: 'obi-threeway-acuator-piston-inleft-right-0',
   elementClass: ObiThreewayAcuatorPistonInleftRight0Element,
   events: {
     
   }
  });
 
 